import { CommunicationServicesStore } from "./types"

export const selectCommunicationServicesState = (state: CommunicationServicesStore) => state.communicationServices
export const selectCommunicationServicesStatus = (state: CommunicationServicesStore) => state.communicationServices.status
export const selectCommunicationServicesData = (state: CommunicationServicesStore) => state.communicationServices.data
export const selectCommunicationServicesError = (state: CommunicationServicesStore) => state.communicationServices.error
